import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { OnboardingAPI } from "../services/onboarding.service";
import { logger } from "../utils/logger";

const PLATFORM_ADMIN_ROLE = "PlatformAdmin";

const RequirePlatformAdmin: React.FC = () => {
  const navigate = useNavigate();
  const [state, setState] = useState<"checking" | "allowed" | "denied">("checking");

  useEffect(() => {
    let cancelled = false;
    OnboardingAPI.getMe()
      .then(({ role }) => {
        if (cancelled) return;
        if (role === PLATFORM_ADMIN_ROLE) {
          setState("allowed");
        } else {
          setState("denied");
          toast.error("Platform Admin access required");
          navigate("/login", { replace: true });
        }
      })
      .catch((err) => {
        if (cancelled) return;
        logger.error("RequirePlatformAdmin: getMe() failed", err instanceof Error ? err : undefined);
        setState("denied");
        navigate("/login", { replace: true });
      });
    return () => { cancelled = true; };
  }, [navigate]);

  if (state === "checking") return null;
  if (state === "denied") return null;
  return <Outlet />;
};

export default RequirePlatformAdmin;
